import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const Restaurant = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    date: '',
    time: '',
    guests: 1
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Booking confirmed!\n\nRestaurant: Privé Park Square\nDate: ${formData.date}\nTime: ${formData.time}\nGuests: ${formData.guests}`);
    navigate('/dashboard');
  };

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Luxury Restaurant Booking</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Privé Park Square</p>

        <img 
          src="/assets/images/res2.jpg" 
          alt="Restaurant" 
          className="product-image mb-lg"
        />

        <div className="card">
          <h2 className="section-title">Privé Park Square</h2>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Date</label>
              <input
                type="date"
                name="date"
                className="form-input"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Time</label>
              <input
                type="time"
                name="time"
                className="form-input"
                value={formData.time}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Number of Guests</label>
              <input
                type="number"
                name="guests"
                className="form-input"
                min="1"
                max="20"
                value={formData.guests}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="btn btn-primary">
              Proceed to Confirmation <span className="service-arrow">→</span>
            </button>
          </form>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default Restaurant;
